import React from 'react'
import {
  Drawer,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react"

import Box from '../components/Box';
import Button from '../components/Button';
import { responsive } from '../contexts/responsive';

const menu = [
  {
    label: '回到首頁',
    to: '/#'
  },
  {
    label: '認識珊瑚礁生態',
    to: '/#preface'
  },
  {
    label: '深入了解體檢計畫的運作',
    to: '/#plan'
  },
  {
    label: '製作團隊',
    to: '/#about/team'
  },
  {
    label: '查看 12 年成果報告',
    to: '/#about'
  },
  {
    label: '聯絡我們',
    to: '/#about/contact'
  },
]

const Menu = ({ isOpen, getFullpageApi, onClose }) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      blockScrollOnMount={false}
    >
      <DrawerContent
        maxWidth={'auto'}
        style={{ width: 'auto' }}
        pt={responsive('4.5em', '6.75em')}
        bg="linear-gradient(rgba(255, 255, 255, 100%) 50%, rgba(255,255,255,0.4))"
      >
        <DrawerCloseButton
          color="custom.lightGray"
          fontSize={responsive('1.25em', '1.875em')}
          right={responsive('1.375em', '2rem')}
          top={responsive('1em', '2.75rem')}
          _hover={{ bg: 'transparent' }}
          _active={{ bg: 'transparent' }}
        />
        <Box>
          {menu.map((d, i) => (
            <Box mx={responsive('1.75em', '3em')} pt={i && responsive('1em', '1.625em')} pb={responsive('1em', '1.625em')} borderTop={i && '1px solid'} borderColor="custom.lightGray" key={i}>
              <Button.Transparent
                onClick={() => {
                  onClose()
                }}
                px="0"
                py="0"
                fontSize={responsive('1.125em', '1.625em')}
                to={d.to}
              >{d.label}</Button.Transparent>
            </Box>
          ))}
        </Box>
      </DrawerContent>
    </Drawer>
  )
}

export default Menu
